import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EventEmitter } from '@angular/core';
import { Media } from '@models/media/media.model';
import { ModelService } from '@services/common/model.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Output } from '@angular/core';

@Component({
  selector: 'app-gallery-modal',
  templateUrl: './gallery-modal.component.html',
  providers: [ModelService],
  styles: [],
})
export class GalleryModalComponent {
  active = 1;
  @Output() closeModal: EventEmitter<void> = new EventEmitter();
  @Output() emitter: EventEmitter<Media> = new EventEmitter();
  @Input() showMyPhotos = true;
  constructor(
    public modal: NgbActiveModal,
    private route: ActivatedRoute,
    private modalService: NgbModal
  ) {}

  close() {
    this.modalService.dismissAll();
    this.closeModal.emit();
  }
}
